<template>
    <div class="landing-page-how-it-works 3xl:tw-max-w-[120rem] tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between tw-items-center tw-px-14 tw-py-14 tw-bg-white">
        <h1 class="how-it-works-title 3xl:tw-text-[3rem] 3xl-tw-leading-[3.625rem] tw-w-[39.375rem] tw-text-center tw-text-[#161C2D] tw-font-poppins tw-text-[2.5rem] tw-font-semibold tw-leading-[3rem] tw-tracking-[-0.1125rem]">
            How it works
        </h1>
        <p
            v-if="isDesktop"
            class="how-it-works-description tw-w-[43.25rem] tw-h-[8.125rem] tw-text-center tw-text-[#161C2D] tw-font-poppins tw-text-xl tw-font-normal tw-leading-8 tw-tracking-[-0.0125rem] tw-opacity-70 tw-flex-shrink-0"
        >
            Your hub has personalized resources to help you manage your home,<br>
            save money, and build wealth.
        </p>
        <p
            v-else
            class="how-it-works-description tw-w-[20.93rem] tw-h-[12rem] tw-text-center tw-text-[#161C2D] tw-font-poppins tw-text-xl tw-font-normal tw-leading-8 tw-tracking-[-0.0125rem] tw-opacity-70 tw-flex-shrink-0"
        >
            Your hub is customized to your home with resources to track your home’s value and equity, save money, and manage maintenance.
        </p>
        <steps
                v-if="isMobile || isTablet"
                :steps="mobileSteps"
        />
        <steps
                v-else
                :steps="steps"
        />

    </div>
</template>

<script>
import Steps from "./Steps/Steps.vue";
import isMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";

export default {
    name: 'LandingPageHowItWorks',
    components: {Steps},
    mixins: [
        isMobileMixin,
    ],
    props: {
        landingPage: {
            type: LandingPageAppResource,
            required: true,
        }
    },
    data() {
        return {
        };
    },
    computed: {
        steps() {
            return [
                {
                    circleColor: this.landingPage.primaryColor,
                    circleContent: 1,
                    circleDashedLine: true,
                    title: 'Claim your home',
                    description: 'Enter your home address to<br> finish setup. Questions?<br> Reach out to us at anytime!',
                },
                {
                    circleColor: this.landingPage.primaryColor,
                    circleContent: 2,
                    circleDashedLine: true,
                    title: 'Explore the features',
                    description: 'Find resources that fit your<br> needs, from home repairs to<br> understanding your home’s<br> value.',
                },
                {
                    circleColor: this.landingPage.primaryColor,
                    circleContent: 3,
                    circleDashedLine: false,
                    title: 'Enjoy the benefits',
                    description: 'Invite others to collaborate,<br> request help when you need<br> it, and enjoy.',
                },
            ];
        },
        mobileSteps() {
            return [
                {
                    circleColor: this.landingPage.primaryColor,
                    circleContent: 1,
                    circleDashedLine: false,
                    title: 'Claim your home',
                    description: 'Enter your home address to<br> finish setup. Questions?<br> Reach out to us at anytime!',
                },
                {
                    circleColor: this.landingPage.primaryColor,
                    circleContent: 2,
                    circleDashedLine: false,
                    title: 'Explore the features',
                    description: 'Find resources that fit your<br> needs, from home repairs to<br> understanding your home’s<br> value.',
                },
                {
                    circleColor: this.landingPage.primaryColor,
                    circleContent: 3,
                    circleDashedLine: false,
                    title: 'Enjoy the benefits',
                    description: 'Invite others to collaborate,<br> request help when you need<br> it, and enjoy.',
                },
            ];
        }
    },
    methods: {
    },
}
</script>
